import React from 'react';
import { Pagination } from '@mantine/core';
import '../styles/components/mantine.css';

const MantinePagination = ({ 
  total = 10, 
  value = 1, 
  onChange, 
  withControls = false 
}) => {
  return (
    <Pagination
      value={value}
      onChange={onChange}
      total={total}
      withControls={withControls}
    />
  );
};

export default MantinePagination;